import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { usePermissions } from '~/entities/common/viewer'
import { Region } from '~/shared/api'
import { timezoneCodeLabels } from '~/shared/config/constants'
import { AsyncGrid } from '~/shared/ui/AsyncGrid'
import type { FetchRowsFn } from '~/shared/ui/AsyncGrid/types'
import { Button } from '~/shared/ui/Buttons'
import { PlusIcon } from '~/shared/ui/Icons'
import { columns } from './columns'
import { GridRow } from './types'

export const ListRegions = () => {
  const { t } = useTranslation()
  const { canRegionsUpdate } = usePermissions()

  const fetchRows = useCallback<FetchRowsFn<GridRow>>(
    async (page, pageSize) => {
      const builder = Region.limit(pageSize).orderBy('-createdAt')

      const response = await builder.get(page)
      const data = response.getData()
      const rows = data.map((region) => ({
        id: region.getApiId() as string,
        timezone: t(timezoneCodeLabels[region.getTimezone()]),
        name: region.getName(),
      }))

      const httpClientResponse = response.getHttpClientResponse()
      const axiosResponse = httpClientResponse?.getUnderlying()
      const total = axiosResponse?.data?.meta?.page?.total || 0

      return {
        rows,
        total,
      }
    },
    [t],
  )

  return (
    <AsyncGrid<GridRow>
      smallTitle={t('regions')}
      gridKey='regions'
      fetchRows={fetchRows}
      columns={columns}
      headerExtra={
        <Button startDecorator={<PlusIcon />} to='new' show={canRegionsUpdate}>
          {t('button.add')}
        </Button>
      }
    />
  )
}
